import { Button, Box, CircularProgress } from "@mui/material";
import React, { useState } from "react";

import { useAuth } from "../../../contexts/AuthContext";
import { GoogleSignInRequestUserTypeEnum } from "../../../libs/cellera-sdk";
import { AuthResult } from "../../../types";

interface GoogleSignInProps {
  userType?: GoogleSignInRequestUserTypeEnum;
  onSuccess?: (result: AuthResult) => void;
  onError?: (error: Error) => void;
  rememberMe: boolean;
  fullWidth?: boolean;
}

const GoogleSignIn: React.FC<GoogleSignInProps> = ({
  userType = GoogleSignInRequestUserTypeEnum.Provider,
  onSuccess,
  onError,
  rememberMe,
  fullWidth = true,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { signInWithGoogle } = useAuth();

  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    try {
      const result = await signInWithGoogle(userType, rememberMe);

      // Handle the case where result might be undefined (redirect flow)
      if (result) {
        if (onSuccess) onSuccess(result);
      }
      // If result is undefined, it means redirect flow is in progress
      // and the callback will be handled by the redirect handler
    } catch (error) {
      if (onError) onError(error as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Button
        variant="outlined"
        className="rounded-full py-3 capitalize text-gray-900"
        fullWidth={fullWidth}
        onClick={handleGoogleSignIn}
        disabled={isLoading}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <div className="flex gap-2 items-center justify-center">
            <img src="/google.svg" alt="Google" />
            <span>Log In With Google</span>
          </div>
        )}
      </Button>
    </Box>
  );
};

export default GoogleSignIn;
